import React from "react";
import HeroSection from "./HeroSection";
import BlogPage from "./BlogPage";

const Blog = () => {
  return (
    <>
      <HeroSection />
      <BlogPage />
    </>
  );
};

export default Blog;
